"use client";

import { motion, useScroll, useTransform } from "framer-motion";
import { useLocale } from "next-intl";
import { FC, useRef } from "react";

import Button, { ButtonSize, ButtonTheme, ButtonVariant } from "@/components/ui/Button/Button";
import { AutoScrollTilesProps } from "@/types";

import "./AutoScrollTiles.css";
import TileScroll from "./TileScroll";

const AutoScrollTiles: FC<AutoScrollTilesProps> = ({ entry }) => {
  const containerRef = useRef<HTMLDivElement>(null);
  const targetRef = useRef<HTMLDivElement>(null);
  const cards1Ref = useRef<HTMLDivElement>(null);
  const cards2Ref = useRef<HTMLDivElement>(null);
  const locale = useLocale();

  const { scrollYProgress } = useScroll({
    target: containerRef,
    offset: ["start end", "end start"],
  });
  const [language, region] = locale.split("-");
  const isRTL = language === "ar";
  const x1 = useTransform(scrollYProgress, [0, 1], isRTL ? [`0`, `-${1400}px`] : [`0`, `${1400}px`]);
  const x2 = useTransform(scrollYProgress, [0, 1], isRTL ? [`0`, `${1400}px`] : [`0`, `-${1400}px`]);
  return (
    <div ref={containerRef} className="min-h-[500px] relative">
      <div className="sticky top-0 w-full mx-auto pt-xxl overflow-hidden">
        <div className="flex justify-center px-m">
          <h2 className="font-primary font-medium text-l text-center uppercase pb-[40px] font-stretch-expanded md:pb-xl md:font-normal md:text-xl">
            {entry.title}
          </h2>
        </div>
        <div ref={targetRef} style={{ ...(isRTL ? { direction: "ltr" } : {}) }}>
          <motion.div ref={cards1Ref} style={{ x: x1 }} className={`flex gap-m mb-m ${isRTL ? "flex-row" : "flex-row-reverse"}`}>
            {entry.cards1 &&
              entry.cards1.map((item, index) => {
                return (
                  <div key={`autoscroll-tile-line-${index}-${item.id}`} className="inline-block w-[390px] shrink-0">
                    <TileScroll item={item} />
                  </div>
                );
              })}
          </motion.div>
          <motion.div
            ref={cards2Ref}
            style={{ x: x2, ...(isRTL ? { direction: "ltr" } : {}) }}
            className={`flex gap-m ${isRTL ? "flex-row-reverse" : ""}`}
          >
            {entry.cards2 &&
              entry.cards2.map((item, index) => {
                return (
                  <div key={`autoscroll-tile-line-${index}-${item.id}`} className="inline-block w-[390px] shrink-0">
                    <TileScroll item={item} />
                  </div>
                );
              })}
          </motion.div>
        </div>
        {entry.cta && (
          <div className="w-full mx-auto text-center mt-l pb-xl">
            <Button
              href={entry.cta.link.url}
              customClass="block w-fit mx-auto"
              size={ButtonSize.MEDIUM}
              theme={ButtonTheme.BLACK}
              type="button"
              variant={ButtonVariant.SECONDARY}
            >
              {entry.cta.label}
            </Button>
          </div>
        )}
      </div>
    </div>
  );
};
export default AutoScrollTiles;
